import {
  setActiveDataRentProg,
  setDataRentProg,
  setIsErrorRentProg,
} from "../../../../store/slices/rentProgSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

export const initRentProg = (dataReq, setLoading, setIsConnected) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/rentprog/create`,
        dataReq
      );

      if (data.code === 200) {
        setIsConnected(true);
        dispatch(getIntegrationsRentProg());
        // dispatch(getIntegrationsAmoList(userId));
        console.log("initRentProg", data);
      } else {
        errorToast("Ошибка инициализации RentProg");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      }

      console.error("initRentProg error:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Удаление интеграции
export const deleteIntegrationRentProg = (dataReq, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/rentprog/delete`,
        dataReq
      );
      if (data.code === 200) {
        // dispatch(setActiveDataAmo(null));
        dispatch(setActiveDataRentProg(null));
        localStorage.removeItem("dataRentProg");
        localStorage.removeItem("activeRentProg");
        getIntegrationsRentProg(userId);
        // console.log("deleteIntegrationRentProg", data);
        navigate("/integration");
        setLoading(false);
      } else {
        setLoading(false);
        errorToast("Ошибка удаления интеграции");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("deleteIntegrationRentProg error:", error);
    }
  };
};

// Получение конкретной интеграции
export const getIntegrationsRentProg = (userId, setLoading = () => {}) => {
  return async (dispatch) => {
    dispatch(setIsErrorRentProg(false));
    setLoading(true);
    try {
      const { data } = await $authHost.get(
        `/integrations/rentprog/list?userId=${userId}`
      );
      if (data.code === 200) {
        setLoading(false);
        if (data.integrations) {
          dispatch(setDataRentProg(data.integrations));
          localStorage.setItem(
            "dataRentProg",
            JSON.stringify(data.integrations)
          );
        }
      } else {
        setLoading(false);
        errorToast("Не удалось получить интеграцию с AmoCRM");
      }
    } catch (error) {
      dispatch(setIsErrorRentProg(false));
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationsRentProg error:", error);
    }
  };
};
